import React from 'react';
import {
  Show,
  SimpleShowLayout,
  TextField,
  BooleanField,
  FunctionField,
  TopToolbar,
  EditButton,
  DeleteButton,
  ListButton,
  DateField,
  ResourceContextProvider,
} from 'react-admin';
import { Box, Breadcrumbs, Link, Typography, Chip } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate, useParams } from 'react-router-dom';

const ShowActions = () => (
  <TopToolbar>
    <ListButton />
    <EditButton />
    <DeleteButton />
  </TopToolbar>
);

const ConfigurationBreadcrumbs = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 2, backgroundColor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
        <Link
          underline="hover"
          color="inherit"
          onClick={() => navigate('/configuration')}
          sx={{ cursor: 'pointer', '&:hover': { color: '#1976d2' } }}
        >
          Configuration
        </Link>
        <Link
          underline="hover"
          color="inherit"
          onClick={() => navigate('/crm/customer-types')}
          sx={{ cursor: 'pointer', '&:hover': { color: '#1976d2' } }}
        >
          Customer Types
        </Link>
        <Typography color="text.primary">Details</Typography>
      </Breadcrumbs>
    </Box>
  );
};

export const CustomerTypeShow = () => {
  const { id } = useParams();

  return (
    <ResourceContextProvider value="crm/customer-types">
      <Show id={id} actions={<ShowActions />}>
        <SimpleShowLayout>
          <ConfigurationBreadcrumbs />
          <TextField source="id" label="ID" />
          <TextField source="name" label="Name" />
          <TextField source="description" label="Description" />
          <FunctionField
            label="Color"
            render={(record: { name?: string; color?: string }) => (
              <Chip
                label={record.color || '#1C5195'}
                size="small"
                sx={{
                  bgcolor: record.color || '#1C5195',
                  color: 'white',
                  fontWeight: 'bold',
                }}
              />
            )}
          />
          <BooleanField source="isActive" label="Active" />
          <TextField source="tenantCode" label="Tenant" />
          <DateField source="createdAt" label="Created At" showTime />
          <DateField source="updatedAt" label="Updated At" showTime />
        </SimpleShowLayout>
      </Show>
    </ResourceContextProvider>
  );
};
